import Axios from "axios";

export const GetCertificateTrackingLinks = async () => {
    try {
        const res = await Axios.get(
            process.env.REACT_APP_API_URL + "getCertificateTrackingLinks/",
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );

        return res.data;
    } catch (error) {
        console.error("Error obteniendo links de seguimiento de certificados", error);

        return error.response?.data || {
            status: 500,
            message: "No fue posible obtener los links de seguimiento",
        };
    }
};

export const PostCertificateTrackingLink = async (folio, tracking_url) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "postCertificateTrackingLink/",
            {
                folio,
                tracking_url,
            },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );

        return res.data;
    } catch (error) {
        console.error("Error registrando link de seguimiento de certificado", error);

        return error.response?.data || {
            status: 500,
            message: "No fue posible registrar el link de seguimiento",
        };
    }
};

export const PatchCertificateTrackingLink = async (id, folio, tracking_url) => {
    try {
        const res = await Axios.patch(
            process.env.REACT_APP_API_URL + `patchCertificateTrackingLink/${id}`,
            {
                folio,
                tracking_url,
            },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );

        return res.data;
    } catch (error) {
        console.error("Error actualizando link de seguimiento de certificado", error);

        return error.response?.data || {
            status: 500,
            message: "No fue posible actualizar el link de seguimiento",
        };
    }
};

export const PatchCertificateTrackingLinkStatus = async (id, st) => {
    try {
        const res = await Axios.patch(
            process.env.REACT_APP_API_URL + `patchCertificateTrackingLinkStatus/${id}`,
            {
                st,
            },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );

        return res.data;
    } catch (error) {
        console.error(
            "Error cambiando estado de link de seguimiento de certificado",
            error
        );

        return error.response?.data || {
            status: 500,
            message: "No fue posible cambiar el estado del link de seguimiento",
        };
    }
};

export const GetMaterialCorrectionTrackingLinks = async () => {
    try {
        const res = await Axios.get(
            process.env.REACT_APP_API_URL + "getMaterialCorrectionTrackingLinks/",
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );

        return res.data;
    } catch (error) {
        console.error("Error obteniendo enlaces de seguimiento de corrección de material", error);

        return error.response?.data || {
            status: 500,
            message: "No fue posible obtener los enlaces de seguimiento de corrección de material",
        };
    }
};

export const PostMaterialCorrectionTrackingLink = async (folio, tracking_url) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "postMaterialCorrectionTrackingLink/",
            {
                folio,
                tracking_url,
            },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );

        return res.data;
    } catch (error) {
        console.error("Error registrando enlace de seguimiento de corrección de material", error);

        return error.response?.data || {
            status: 500,
            message: "No fue posible registrar el enlace de seguimiento de corrección de material",
        };
    }
};

export const PatchMaterialCorrectionTrackingLink = async (id, folio, tracking_url) => {
    try {
        const res = await Axios.patch(
            process.env.REACT_APP_API_URL + `patchMaterialCorrectionTrackingLink/${id}`,
            {
                folio,
                tracking_url,
            },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );

        return res.data;
    } catch (error) {
        console.error("Error actualizando enlace de seguimiento de corrección de material", error);

        return error.response?.data || {
            status: 500,
            message: "No fue posible actualizar el enlace de seguimiento de corrección de material",
        };
    }
};

export const PatchMaterialCorrectionTrackingLinkStatus = async (id, st) => {
    try {
        const res = await Axios.patch(
            process.env.REACT_APP_API_URL + `patchMaterialCorrectionTrackingLinkStatus/${id}`,
            {
                st,
            },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );

        return res.data;
    } catch (error) {
        console.error(
            "Error cambiando estado de enlace de seguimiento de corrección de material",
            error
        );

        return error.response?.data || {
            status: 500,
            message: "No fue posible cambiar el estado del enlace de seguimiento de corrección de material",
        };
    }
};

export const PostAddPromotionToGroup = async (idGroup, concept, type_promotion, percentage, date_begin, date_end) => {
    try {
        const res = await Axios.post(process.env.REACT_APP_API_URL + "postAddPromotionToGroup/", {
            idGroup, concept, type_promotion, percentage, date_begin, date_end
        }, {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        })
        return res.data
    } catch (error) {
        console.log(error)
    }
}

export const EditUnitTeacherClasses = async (fk_subsidiary)=>{
    try {
        const res = await Axios.patch(process.env.REACT_APP_API_URL + "editUnitTeacherClasses/", {
            fk_subsidiary
        }, {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        })
        return res.data
    } catch (error) {
        console.log(error)
    }
}
export const GetUnitLimitsGroup = async (fk_subsidiary)=>{
    try {
        const res = await Axios.post(process.env.REACT_APP_API_URL + "getUnitLimitsGroup/", {
            fk_subsidiary
        }, {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        })
        return res.data
    } catch (error) {
        console.log(error)
    }
}

export const PatchEndPromotionGroup = async (rel_promotion_id, id_group) => {
    try {
        const res = await Axios.patch(process.env.REACT_APP_API_URL + "patchEndPromotionGroup/", {
            rel_promotion_id, id_group
        }, {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        })
        return res.data
    } catch (error) {
        console.log(error)
    }
}

export const GetAllTeachersBySubsidiaryOrInchargeReceptionist = async (receptionist_id, subsidiary_id, isbyReceptionistInCharge) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "getAllTeachersBySubsidiaryOrInchargeReceptionist/",
            { receptionist_id, subsidiary_id, isbyReceptionistInCharge },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error obteniendo maestros", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
};
export const GetAllReceptionistBySubsidiaryOrAllTeachersByReceptionistInCharge = async (receptionist_id, subsidiary_id, isbyReceptionistInCharge) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "getAllReceptionistBySubsidiaryOrAllTeachersByReceptionistInCharge/",
            { receptionist_id, subsidiary_id, isbyReceptionistInCharge },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error obteniendo maestros o recepcionistas", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
};
export const GetAllTeacherClassesByEmployeeIdForDebts = async (employee_id) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "getAllTeacherClassesByEmployeeIdForDebts/",
            { employee_id },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error obteniendo los recibos del alumno", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
};

export const GetAllTeacherClassesNoEliminatedNoDaysOffNoFinishedByEmployeeId = async (employee_id) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "getAllTeacherClassesNoEliminatedNoDaysOffNoFinishedByEmployeeId/",
            { employee_id },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error obteniendo los grupos del profesor", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
};
export const GetAllTeacherThatIsInChargeReceptionistByEmployeeId = async (employee_id) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "getAllTeacherThatIsInChargeReceptionistByEmployeeId/",
            { employee_id },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error obteniendo profesores", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
};
